import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { RoleLevel } from '../services/reportService/setting.enum';


@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {
 
  customize: boolean = true;
  expand: boolean = false;
 
  rolesAsssign: any[] = [];
  navItems: any[] = [];
  isOfficeAdmin: boolean;
  isOrganizationAdmin: boolean;
  isSuperAdmin: boolean;

  constructor(private _dataSharingService: DataSharingService) {

  }

  ngOnInit(): void {
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

    //
    if (this.rolesAsssign.length > 0) {
      this.isOfficeAdmin = this.rolesAsssign.find(m => m.roleName == 'Office Admin') != undefined;
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }
  
    if(this.rolesAsssign.length > 0){
      var Superadmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      Superadmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(Superadmin.length > 0){
        this.ShowPDFFormsReport();   
        this.ManageAITemplates();     
        return;
      }

      var OrganizationAdmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      OrganizationAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin);
      if(OrganizationAdmin.length > 0){       
        this.ShowPDFFormsReport();               
        this.ManageAITemplates();   
        return;
      }

      var OfficeAdmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      OfficeAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
      if(OfficeAdmin.length > 0){        
        this.ShowPDFFormsReport();            
        this.ManageAITemplates();       
        return;
      }    

      var User=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      User= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.User);
      if(User.length > 0){       
        this.ShowPDFFormsReport();     
        this.ManageAITemplates(); 
        return;
      }
    }   
  }
  
   // Show only Super admin / Organization Admin / OfficeAdmin
   ShowPDFFormsReport(){
    var ReqModel={
    id: '1',
    name : 'PDF Forms Report',
    items :[
      {
        name: 'Form Use Report',
        link: 'manageFormUseReport',
      },
      {
        name: 'Project Status Report',
        link: 'manageProjectStatusReport',
      },
      {
        name: 'Project Data Report',
        link: 'manageProjectDataReport',
      },      
    ]
    } 
    this.navItems.push(ReqModel);
   }
  

   ManageHTMLFormReport(){
    var ReqModel={
      id: '3',
      name : 'HTML Form Report',
      items :[
        {
          name: 'Form Use Report',
          link: 'manageFormUseReport',
        },
        {
          name: 'Project Status Report',
          link: 'manageFormDataReport',
        },
        ],
     } 
     this.navItems.push(ReqModel);    
   }
      
   ManageAITemplates(){
    var ReqModel={
      id: '22',
      name : 'AI Reports' ,
      items :[            
        {
          name: 'Automation Process Report',
          link: 'manageAutomationProcessReport',
        },             
      ] 
     }   
      this.navItems.push(ReqModel);    
   }  
   
  expandNav(){
    this.expand = !this.expand
  }
  

  linkclick(link){    
    if(link.name == "My Profile"){
      sessionStorage.setItem('HeaderModuleName', link.name);   
      this._dataSharingService.sendSelectedModuleName(link.name);
    }   
  }

}


